<template>
  <div class="ranking-card">

    <!-- 固定的头部标题栏 -->
    <div class="card-header">
      <div class="icon-bar">
        <span class="bar bar-1"></span>
        <span class="bar bar-2"></span>
        <span class="bar bar-3"></span>
      </div>
      <span class="title">已投放省市排行 (按小区数排序)</span>
    </div>

    <!-- 💥 核心：可滚动的列表区域使用 transition-group包裹 -->
    <!-- 增加鼠标移入暂停(@mouseenter)、移出恢复(@mouseleave)的交互 -->
    <transition-group
      name="slide"
      tag="div"
      class="list-container"
      @mouseenter="stopScroll"
      @mouseleave="startScroll"
    >
      <!-- 注意：这里的 key 必须绑定数据的唯一标识（如省份名或ID），绝对不能用 index！ -->
      <div
        class="list-item"
        v-for="item in listData"
        :key="item.provinceCode"
      >
        <div class="province-name">{{ item.provinceName }}</div>
        <div class="stats-info">
          车辆:<span class="num">{{ item.putNum }}</span>台 ·
          小区:<span class="num">{{ item.putCommunityNum }}</span>个
        </div>
      </div>
    </transition-group>

    <div v-if="loading" class="loading-text">数据加载中...</div>

  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const listData = ref([]);
const loading = ref(false);

let timer = null; // 定时器实例



// ================== 1. 获取数据 ==================
const setListData = (list) => {
  stopScroll()
  listData.value = list
  startScroll();
}
defineExpose({
  setListData
})
// const fetchRankingData = async () => {
//   loading.value = true;
//   try {
//     // 模拟接口请求延迟
//     await new Promise(resolve => setTimeout(resolve, 500));
//
//     listData.value = [
//       { province: '广东', carCount: 56, communityCount: 210 },
//       { province: '上海', carCount: 38, communityCount: 156 },
//       { province: '北京', carCount: 42, communityCount: 128 },
//       { province: '江苏', carCount: 24, communityCount: 98 },
//       { province: '浙江', carCount: 18, communityCount: 76 },
//       { province: '四川', carCount: 14, communityCount: 52 },
//       { province: '重庆', carCount: 11, communityCount: 43 },
//       { province: '湖北', carCount: 12, communityCount: 38 },
//       { province: '天津', carCount: 8, communityCount: 29 },
//     ];
//
//     // 数据拿回来之后，开始定时滚动
//     startScroll();
//
//   } catch (error) {
//     console.error(error);
//   } finally {
//     loading.value = false;
//   }
// };

// ================== 2. 核心自动滚动逻辑 ==================
// 开启滚动
const startScroll = () => {
  // 防抖保护，避免重复开启定时器
  if (timer) clearInterval(timer);

  // 每隔 3000ms (3秒) 执行一次
  timer = setInterval(() => {
    if (listData.value.length > 0) {
      // 提取数组的第一个元素，并把它塞到数组的最后面
      const firstItem = listData.value.shift();
      listData.value.push(firstItem);
    }
  }, 3000);
};

// 停止滚动
const stopScroll = () => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
};

// ================== 生命周期钩子 ==================
onMounted(() => {
  // fetchRankingData();
});

// 组件销毁前务必清除定时器，防止内存泄漏
onUnmounted(() => {
  stopScroll();
});
</script>

<style scoped>
/* ================= 外层卡片 ================= */
.ranking-card {
  width: 100%;
  height: 100%;
  background-color: #0b1426;
  border: 1px solid #1a2a46;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 16px;
  font-family: 'Microsoft YaHei', sans-serif;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  flex-shrink: 0;
}

.icon-bar {
  display: flex;
  align-items: flex-end;
  height: 14px;
  gap: 2px;
  margin-right: 8px;
}

.bar {
  width: 4px;
  border-radius: 2px;
}

.bar-1 {
  height: 60%;
  background-color: #00e573;
}

.bar-2 {
  height: 100%;
  background-color: #ffc107;
}

.bar-3 {
  height: 80%;
  background-color: #ff4d4f;
}

.title {
  color: #00d2ff;
  font-size: 15px;
  font-weight: bold;
}

/* ================= 列表区域 ================= */
.list-container {
  flex: 1;
  /* 🚨 核心修改：改为 hidden，隐藏真实的滚动条 */
  overflow: hidden;
  position: relative;
}

.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(26, 42, 70, 0.8);
  background-color: #0b1426; /* 给一个底色防止动画重叠时穿透 */
  /* 设置一个固定的高度，有助于动画更稳定 */
  box-sizing: border-box;
}

.list-item:last-child {
  border-bottom: none;
}

.list-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
  cursor: pointer;
}

.province-name {
  color: #ffffff;
  font-size: 14px;
}

.stats-info {
  color: #1e70ff;
  font-size: 13px;
}

.loading-text {
  color: #8a9ab9;
  text-align: center;
  margin-top: 20px;
  font-size: 13px;
}

/* ================= 💥 Vue 丝滑动画核心 CSS ================= */
/* 动画过渡时间与缓动效果 */
.slide-move,
.slide-enter-active,
.slide-leave-active {
  transition: all 0.6s ease-in-out;
}

/* 进入时的初始状态 (从底部出现) */
.slide-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

/* 离开时的结束状态 (向上方消失) */
.slide-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

/* 🚨 绝对核心：让离开的元素脱离文档流，后续元素才能平滑补位上移 */
.slide-leave-active {
  position: absolute;
  width: 100%;
}
</style>
